import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { loadUnidade } from 'src/app/store/unidade/unidade.actions';
import { selectUnidadeLista, selectUnitActiveList } from 'src/app/store/unidade/unidade.selectors';
import { Output, EventEmitter } from '@angular/core';
import { FilterMenuService } from '../../services/filter-menu.service';

@Component({
  selector: 'split-filter-menu',
  templateUrl: './split-filter-menu.component.html',
  styleUrls: ['./split-filter-menu.component.scss']
})
export class SplitFilterMenuComponent implements OnInit {

  @Output() filterEvent = new EventEmitter();
  @Input() filterBySplit: boolean = false
  @Input() filterByAddress: boolean = false
  @Input() address: any

  dataAtual = new Date();
  anoAtual = Number(this.datePipe.transform(this.dataAtual, 'yyyy'));
  mesAtual = this.dataAtual.getMonth()
  monthOptions: Array<any> = []
  monthToMonthOptions: any
  unitsFromAPI$ = this.store.select(selectUnitActiveList);
  unitOptions: any
  form = this.fb.group({
    selectButtonFrequency: ['moth-to-month', Validators.required],
    dropdownPeriod: [null as any, Validators.required],
    dropdownUnit: [''],
    dropdownSplit: ['all', Validators.required],
    dropdownAddress: ['']
  })

  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private store: Store,
    private filterMenuService: FilterMenuService
  ) { }

  ngOnInit(): void {
    this.store.dispatch(loadUnidade())
    this.monthOptions = this.getLast12Months()
    
    this.unitsFromAPI$.subscribe({
      next: res => {
        if (res.length) {
          this.unitOptions = res;
          this.addNewFilterEvent()
        }
      },
      error: err => console.log(err)
    })
    
    //console.log('mes atual: ', this.mesAtual)
    this.form.controls.dropdownPeriod.setValue(this.monthOptions[0].value)
  }

  getLast12Months() {
    const today = new Date();
    let currentMonth = today.getMonth();
    let currentYear = today.getFullYear()
    const months = [];
    const monthData = [
      { label: `01 - 31 Janeiro`, value: 1 },
      { label: `01 - 28 Fevereiro`, value: 2 },
      { label: `01 - 31 Março`, value: 3 },
      { label: `01 - 30 Abril`, value: 4 },
      { label: `01 - 31 Maio`, value: 5 },
      { label: `01 - 30 Junho`, value: 6 },
      { label: `01 - 31 Julho`, value: 7 },
      { label: `01 - 31 Agosto`, value: 8 },
      { label: `01 - 30 Setembro`, value: 9 },
      { label: `01 - 31 Outubro`, value: 10 },
      { label: `01 - 30 Novembro`, value: 11 },
      { label: `01 - 31 Dezembro`, value: 12 },
      ]
    
    for (let i = 0; i < 12; i++) {

      months.push({ 
        label: `${monthData[currentMonth].label} - ${currentYear}`, 
        value: { month: monthData[currentMonth].value, year: currentYear }
      })
      currentMonth--;
      if (currentMonth < 0) {
        currentMonth = 11; // Vai para dezembro do ano anterior
        currentYear--;
      }
      
    }

    return months
    
  }

  addNewFilterEvent() {
    
    let form = this.form.controls
    
    if (this.filterBySplit) {
      if (
        form.selectButtonFrequency.invalid ||
        form.dropdownPeriod.invalid ||
        //form.dropdownUnit.invalid ||
        form.dropdownSplit.invalid
      ) {
        return
      }
      let filterOptions = {
        frequency: this.form.value.selectButtonFrequency,
        period: this.form.value.dropdownPeriod,
        unit: this.form.value.dropdownUnit,
        split: this.form.value.dropdownSplit
      }

      return this.filterEvent.emit(filterOptions);

    } else if (this.filterByAddress) {

      let filterOptions = {
        frequency: this.form.value.selectButtonFrequency,
        period: this.form.value.dropdownPeriod,
        address: this.form.value.dropdownAddress
      }

      this.filterEvent.emit(filterOptions);

    } else {
      let filterOptions = {
        frequency: this.form.value.selectButtonFrequency,
        period: this.form.value.dropdownPeriod,
        unit: this.form.value.dropdownUnit
      }

      this.filterEvent.emit(filterOptions);
    }


    


  }

  onOptionClick(event: any) {

    this.form.controls.dropdownPeriod.setValue('')

    switch (event.option.value) {
      case 'moth-to-month':
        this.monthOptions = this.getLast12Months();
        break;
      case 'quarterly':
        this.monthOptions = this.quarterlyOptions
        break;
      case 'yearly':
        this.monthOptions = this.yearlyOptions
        break;
    }

    this.form.controls.dropdownPeriod.setValue(this.monthOptions[0].value)


    this.addNewFilterEvent()

  }

  // monthToMonthOptions = [
  //   { label: `01 - 31 Janeiro ${this.anoAtual}`, value: '1' },
  //   { label: `01 - 28 Fevereiro ${this.anoAtual}`, value: '2' },
  //   { label: `01 - 31 Março ${this.anoAtual}`, value: '3' },
  //   { label: `01 - 30 Abril ${this.anoAtual}`, value: '4' },
  //   { label: `01 - 31 Maio ${this.anoAtual}`, value: '5' },
  //   { label: `01 - 30 Junho ${this.anoAtual}`, value: '6' },
  //   { label: `01 - 31 Julho ${this.anoAtual}`, value: '7' },
  //   { label: `01 - 31 Agosto ${this.anoAtual}`, value: '8' },
  //   { label: `01 - 30 Setembro ${this.anoAtual}`, value: '9' },
  //   { label: `01 - 31 Outubro ${this.anoAtual}`, value: '10' },
  //   { label: `01 - 30 Novembro ${this.anoAtual}`, value: '11' },
  //   { label: `01 - 31 Dezembro ${this.anoAtual}`, value: '12' },
  // ]

  quarterlyOptions = [
    { label: 'Janeiro - Março', value: '1-3' },
    { label: 'Abril - Junho', value: '4-6' },
    { label: 'Julho - Setembro', value: '7-9' },
    { label: 'Outubro - Dezembro', value: '10-12' }
  ]

  yearlyOptions = [
    { label: `${this.anoAtual}`, value: `${this.anoAtual}` },
    { label: `${this.anoAtual! - 1}`, value: `${this.anoAtual! - 1}` },
    { label: `${this.anoAtual! - 2}`, value: `${this.anoAtual! - 2}` },
    { label: `${this.anoAtual! - 3}`, value: `${this.anoAtual! - 3}` },
    { label: `${this.anoAtual! - 4}`, value: `${this.anoAtual! - 4}` },
  ]


}
